<template>
  <div id="verify-tree-grid" class="grid-view">
    <div class="main-content">
      <div slot="operations">
        <div>
          <el-form
            label-width="100px"
            label-position="left"
            style="margin-right:10px;padding-top: 10px"
          >
            <el-row>
              <!--   第一列          -->
              <el-col :span="6">
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.FileNo')"
                  prop="fileNo"
                >
                  <el-input v-model="query.fileNo" no="1" />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.BusinessNo')"
                  prop="jobNo"
                >
                  <el-input v-model="query.jobNo" no="2" />
                </el-form-item>
                <div style="padding-bottom: 5px;margin-right: 10px;display: flex">
                  <el-select
                    v-model="query.timeType"
                    no="3"
                    style="min-width: 100px"
                    @change="setQuerySelectValue"
                  >
                    <el-option
                      v-for="(item,index) in timeTypes"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                  <el-date-picker
                    v-model="query.timeStart"
                    no="4"
                    style="width: 100%"
                    type="date"
                    value-format="yyyy-MM-dd"
                  />
                  <span style="padding-top: 5px">{{ $t('CargoMsg.Cargo_To') }}</span>
                  <el-date-picker
                    v-model="query.timeEnd"
                    no="5"
                    style="width: 100%"
                    type="date"
                    value-format="yyyy-MM-dd"
                  />
                </div>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.CustomsBroker')"
                  prop="customsBroker"
                >
                  <cargo-company-select
                    no="6"
                    :placeholder="' '"
                    :method-params="{customsBroker:true}"
                    :default-value="query.customsBroker||''"
                    style="width:250px;"
                    @change="p=>{query.customsBroker=p.value}"
                  />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="this.$t('SeaExport.Hbl2')"
                  prop="jobHbl"
                >
                  <el-input v-model="query.jobHbl" no="7" />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="this.$t('SeaExport.PortOfLoadingAI')"
                  prop="loadingPortCode"
                >
                  <cargo-advance-select
                    ref="pod"
                    no="8"
                    :select-type="query.portType==='AE'?selectTypeNames.basic_data_Airport:selectTypeNames.basic_data_Seaport"
                    filterable
                    :placeholder="' '"
                    :default-value="query.loadingPortCode"
                    tag-name="englishName"
                    @parentCallBack="p=>{query.loadingPortCode=p.code}"
                  />
                </el-form-item>
              </el-col>
              <!--   第二列          -->
              <el-col :span="6">
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.FileType')"
                  prop="fileTypes"
                >
                  <cargo-advance-select
                    no="9"
                    filterable
                    :multiple="true"
                    :placeholder="' '"
                    :data-filter-function="dataFilterFunc"
                    callback-method-type="value"
                    :select-type="selectTypeNames.basic_data_TransmitFileType"
                    :default-multiple-value="query.fileTypes"
                    :tag-value="'name'"
                    @parentCallBack="value=>query.fileTypes=[...value]"
                  />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.Customer')"
                  prop="customerId"
                >
                  <cargo-company-select
                    no="10"
                    :placeholder="' '"
                    class="shipper-selector"
                    popper-class="shipper-selector-popper"
                    :method-params="{customer:true}"
                    :default-value="query.customerId||''"
                    style="flex: 1;"
                    @change="p=>{query.customerId=p.value}"
                  />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.CollectionSituation')"
                  prop="clearState"
                >
                  <el-select
                    v-model="query.clearState"
                    no="11"
                    :placeholder="' '"
                    clearable
                    @change="setQuerySelectValue"
                  >
                    <el-option
                      v-for="(item,index) in cTypes"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>

                <el-form-item
                  class="query-input-spacing"
                  :label="'PO. No.'"
                  prop="customerRefNo"
                >
                  <el-input v-model="query.customerRefNo" no="12" />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.SoNo')"
                  prop="soNo"
                >
                  <el-input v-model="query.soNo" no="13" />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="this.$t('SeaExport.PortOfDestination')"
                  prop="destinationPortCode"
                >
                  <cargo-advance-select
                    ref="pod"
                    no="14"
                    :placeholder="' '"
                    :select-type="query.portType==='AE'?selectTypeNames.basic_data_Airport:selectTypeNames.basic_data_Seaport"
                    filterable
                    :default-value="query.destinationPortCode"
                    tag-name="englishName"
                    @parentCallBack="p=>query.destinationPortCode=p.code"
                  />
                </el-form-item>
              </el-col>
              <!--   第三列          -->
              <el-col :span="6">
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.BusinessType')"
                  prop="jobLobs"
                >
                  <cargo-advance-select
                    no="15"
                    :select-type="selectTypeNames.local_cache_SystemConstants$LOBS"
                    filterable
                    :placeholder="' '"
                    callback-method-type="value"
                    :multiple="true"
                    :default-multiple-value="query.jobLobs"
                    @parentCallBack="value=>query.jobLobs=[...value]"
                  />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.CustomsNo')"
                  prop="customsNo"
                >
                  <el-input v-model="query.customsNo" no="16" />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.Mbl2')"
                  prop="jobMbl"
                >
                  <el-input v-model="query.jobMbl" no="17" />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.ShippingCompany')"
                  prop="jobCarrierId"
                >
                  <cargo-company-select
                    no="18"
                    :placeholder="' '"
                    :method-params="{seaCmp:true}"
                    :default-value="query.jobCarrierId||''"
                    @change="p=>{query.jobCarrierId=p.value}"
                  />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.Vessel')"
                  prop="vessel"
                >
                  <cargo-advance-select
                    no="19"
                    filterable
                    clearable
                    :placeholder="' '"
                    :select-type="selectTypeNames.basic_data_Vessel"
                    tag-name="englishName"
                    tag-value="englishName"
                    :default-value="query.vessel"
                    @parentCallBack="p=>{query.vessel=p.value}"
                  />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('CargoMsg.Cargo_TypeOfPort')"
                  prop="portType"
                >
                  <el-radio-group v-model="query.portType" no="20">
                    <el-form-item>
                      <el-radio label="SE" style="float:left">{{ $t('CargoMsg.Cargo_OceanFreight') }}</el-radio>
                      <el-radio label="AE" style="float:left">{{ $t('CargoMsg.Cargo_Air') }}</el-radio>
                    </el-form-item>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <!--  第四列          -->
              <el-col :span="6">
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.Status')"
                  prop="status"
                >
                  <cargo-advance-select
                    no="21"
                    filterable
                    clearable
                    :select-type="selectTypeNames.local_cache_SystemConstants$FILE_STATUS3"
                    :placeholder="' '"
                    :default-value="query.status || ''"
                    @parentCallBack="p=>{query.status=p.value}"
                  />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.OperatingCompany')"
                  prop="companyCName"
                >
                  <el-input v-model="query.companyCName" no="22" />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.Sales')"
                  prop="jobSales"
                >
                  <cargo-user-select
                    no="23"
                    :method-params="{category:'role',shape:'sales'}"
                    :default-value="query.jobSales"
                    :placeholder="' '"
                    @change="p=>{query.jobSales=p.value}"
                  />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.SalesDepartment')"
                  prop="jobSalesDepartments"
                >
                  <cargo-advance-select
                    no="24"
                    :select-type="selectTypeNames.basic_data_Department_All"
                    filterable
                    :placeholder="' '"
                    callback-method-type="value"
                    :multiple="true"
                    :default-multiple-value="query.jobSalesDepartments"
                    @parentCallBack="value=>query.jobSalesDepartments=[...value]"
                  />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.Voyage')"
                  prop="voyageFlight"
                >
                  <el-input v-model="query.voyageFlight" no="25" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div>
            <!--检索-->
            <el-button no="26" type="primary" @click="queryHandler">{{ $t('CargoMsg.Cargo_Search') }}</el-button>
            <!--取回-->
            <el-button v-show="$checkPermission(['button_CRFileBack_file'])" no="27" type="primary" @click="onBack">{{ $t('SeaExport.Back') }}</el-button>
            <!--退还-->
            <el-button v-show="$checkPermission(['button_CRFileBack_file'])" no="28" :disabled="!opButton.btReturn" type="primary" @click="onReturn">{{ $t('CargoMsg.Cargo_SendBack') }}</el-button>
            <!--撤销退还-->
            <el-button v-show="$checkPermission(['button_CRFileBack_file'])" no="29" :disabled="!opButton.btCancelReturn" type="primary" @click="onCancelReturn">{{ $t('CargoMsg.Cargo_RevokeWithdrawal') }}</el-button>
            <!--退还列表-->
            <el-button no="30" :disabled="!opButton.backListBtn" type="primary" @click="popUpBackList">{{ $t('CargoMsg.Cargo_RetreatASingle') }}</el-button>
            <!--收款信息-->
            <el-button no="31" :disabled="!opButton.gatherBtn" type="primary" @click="popUpInvoiceInfo">{{ $t('CargoMsg.Cargo_CollectFormation') }}</el-button>
            <!--打印(退单清单)-->
            <el-button no="32" type="primary" @click="onPrint">{{ $t('CargoMsg.Cargo_PrintWithdrawalList') }}</el-button>
            <!--重置条件-->
            <el-button no="33" type="primary" @click="clearPage">{{ $t('CargoMsg.Cargo_ResetFilter') }}</el-button>
          </div>
        </div>
      </div>
      <div style="display:flex;height:65%">
        <div style="display: flex;flex-direction: column;width: 100%;" class="section">
          <cargo-ag-grid
            config-module="9500001"
            :locale-text-func="_i18nGridLocalText"
            :grid-options="businessList.gridOptions"
            :column-defs="businessList.columnDefs"
            :row-data="businessList.rowData"
            :grid-params.sync="businessList.gridParams"
            class="ag-theme-balham"
            style="width: 100%;height:60%"
            @gridReady="onGridReady"
          />
          <div class="pagination-wrapper">
            <cargo-pagination
              config-module="9500003"
              :total="businessList.total"
              :page.sync="businessList.filter.pageNum"
              :limit.sync="businessList.filter.pageSize"
              @pagination="toQueryByPage"
            />
          </div>
        </div>
      </div>

      <div class="section">
        <div>
          <el-form :inline="true" label-width="85px" label-position="left" style="padding-top:5px">
            <el-form-item :label="this.$t('SeaExport.Customer')" class="custom">
              <cargo-company-select
                no="34"
                :readonly="true"
                :custom-style="'width:160px'"
                :disabled="true"
                :placeholder="' '"
                popper-class="shipper-selector-popper"
                :method-params="{customer:true}"
                :default-value="businessList.selectedData.customerId||''"
              />
            </el-form-item>
            <el-form-item :label="this.$t('CargoMsg.Cargo_CustomerAddress')" class="custom">
              <el-input v-model="businessList.selectedData.expressAddress" no="35" :title="businessList.selectedData.expressAddress" :readonly="true" style="width:160px" :disabled="true" />
            </el-form-item>
            <el-form-item :label="this.$t('SeaExport.BookingAgent')" class="custom">
              <cargo-advance-select
                no="36"
                style="width:160px;"
                :readonly="true"
                :disabled="true"
                :placeholder="' '"
                :tag-name="'shortName'"
                :method-params="{bookingAgent:true}"
                :select-type="selectTypeNames.basic_data_Company"
                :default-value="businessList.selectedData.bookingAgent||''"
                @parentCallBack="p=>businessList.selectedData.bookingAgent=p.cmpIdx"
              />
            </el-form-item>
          </el-form>
          <el-form :inline="true" label-width="85px" label-position="left" style="padding-top:5px">
            <el-form-item :label="this.$t('CargoMsg.Cargo_VesselAndVoyage')" class="custom">
              <el-input
                no="37"
                :value="getVesselAndVoyage()"
                :readonly="true"
                style="width:160px"
                :disabled="true"
              />
            </el-form-item>
            <el-form-item :label="this.$t('CargoMsg.Cargo_SailingDay')" class="custom">
              <el-date-picker
                v-model="businessList.selectedData.etd"
                no="38"
                :readonly="true"
                :disabled="true"
                type="date"
                style="width:160px"
                clearable
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item :label="this.$t('SeaExport.CustomsBroker')" class="custom">
              <cargo-company-select
                no="39"
                :disabled="true"
                :placeholder="' '"
                :method-params="{customsBroker:true,seaExport:true,active:true}"
                :default-value="businessList.selectedData.customsBroker||''"
                :custom-style="'width:160px;'"
                @change="p=>{businessList.selectedData.customsBroker=p.value}"
              />
            </el-form-item>
          </el-form>

          <el-form :inline="true" label-width="85px" label-position="left" style="padding-top:5px">
            <el-form-item :label="this.$t('CargoMsg.Cargo_RefNbr')" class="custom">
              <el-input
                no="40"
                :value="businessList.selectedData.lob !== 'SE'?businessList.selectedData.mbl : businessList.selectedData.soNo"
                :readonly="true"
                style="width:160px"
                :disabled="true"
              />
            </el-form-item>
            <el-form-item :label="this.$t('CargoMsg.Cargo_CustomsNo')" class="custom">
              <el-input v-model="businessList.selectedData.customsNo" no="41" :readonly="true" style="width:160px" :disabled="true" />
            </el-form-item>
            <el-form-item :label="this.$t('SeaExport.Operation')" class="custom">
              <cargo-advance-select
                no="42"
                :readonly="true"
                :disabled="true"
                style="width:160px"
                filterable
                :placeholder="' '"
                :select-type="selectTypeNames.basic_data_User"
                callback-method-type="value"
                :default-value="businessList.selectedData.op===0?'':businessList.selectedData.op"
                :callback-params="{key:'op'}"
                @parentCallBack="setQuerySelectValue"
              />
            </el-form-item>
            <el-form-item :label="this.$t('SeaExport.Sales')" class="custom">
              <cargo-advance-select
                no="43"
                :readonly="true"
                :disabled="true"
                style="width:160px"
                filterable
                :placeholder="' '"
                :select-type="selectTypeNames.basic_data_User"
                callback-method-type="value"
                :default-value="businessList.selectedData.salesId===0?'':businessList.selectedData.salesId"
                :callback-params="{key:'sales'}"
                @parentCallBack="setQuerySelectValue"
              />
            </el-form-item>
          </el-form>
          <el-form :inline="true" label-width="85px" label-position="left">
            <el-form-item :label="$t('SeaExport.Remarks')" class="custom">
              <el-input
                v-model="businessList.selectedData.remark"
                no="44"
                type="textarea"
                :rows="3"
                :readonly="true"
                style="width:1000px"
                :disabled="true"
              />
            </el-form-item>
          </el-form>

          <el-form :inline="true" label-width="85px" label-position="left" style="padding-top:5px">
            <el-form-item :label="this.$t('CargoMsg.Cargo_RecipientSCompanyOfWithdrawal')" class="custom">
              <el-input v-model="businessList.selectedData.receiveCompany" no="45" :readonly="true" style="width:160px" :disabled="true" />
            </el-form-item>
            <el-form-item :label="this.$t('CargoMsg.Cargo_RecipientOfWithdrawal')" class="custom">
              <el-input v-model="businessList.selectedData.receivePerson" no="46" :readonly="true" style="width:160px" :disabled="true" />
            </el-form-item>
            <el-form-item :label="this.$t('CargoMsg.Cargo_Tel')" class="custom">
              <el-input v-model="businessList.selectedData.receiveTel" no="47" :readonly="true" style="width:160px" :disabled="true" />
            </el-form-item>
            <el-form-item :label="this.$t('CargoMsg.Cargo_ReturnOrderExpressNumber')" class="custom">
              <el-input v-model="businessList.selectedData.returnExpressNo" no="48" :readonly="true" style="width:160px" :disabled="true" />
            </el-form-item>
          </el-form>
          <el-form :inline="true" label-width="85px" label-position="left">
            <el-form-item :label="$t('CargoMsg.Cargo_WithdrawalAddress')" class="custom">
              <el-input
                v-model="businessList.selectedData.expressAddress"
                no="49"
                type="textarea"
                :rows="3"
                :readonly="true"
                style="width:1000px"
                :disabled="true"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>

    </div>

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />

    <!--    送出-->
    <dc-send-out-window
      ref="dcSendOut"
      :send-out-dialog="sendOutDialog"
      :visible="sendOutDialog.visible"
      :job="job"
      :selected-files="selectedFiles"
      @successHandler="successHandler"
    />
    <!-- 文件编辑弹框 -->
    <file-dialog ref="fileDialog" :visible.sync="editDialog.visible" :is-remark-only="editDialog.isRemarkOnly" :selected-file="businessList.selectedData" :job="job" @successHandler="successHandler" />
    <!--    取回-->
    <dc-take-back-window
      ref="dcTakeBack"
      :take-back-dialog="takeBackDialog"
      :visible="takeBackDialog.visible"
      :job="job"
      :selected-files="takeBackDialog.selectedFiles"
      @successHandler="backSuccessHandler"
    />

    <!--    退还-->
    <dc-return-window
      ref="dcReturn"
      :return-dialog="returnDialog"
      :visible="returnDialog.visible"
      :selected-files="selectedFiles"
      @successHandler="backSuccessHandler"
    />
    <!-- 退单列表 -->
    <back-list-window
      ref="dcReturn"
      :row-list="backList.rowList"
      :visible="backList.visible"
      @visibleHandler="visibleHandler"
    />
    <!--   收款信息 -->
    <collect-info-window
      ref="dcReturn"
      :row-list="collectInfo.rowList"
      :visible="collectInfo.visible"
      @visibleHandler="visibleHandler"
    />

    <!-- 云文件上传对话框 -->
    <cargo-custom-info-file-upload
      :visible.sync="cloudFile.visible"
      :job="job"
      :title="cloudFile.title"
      :custom-info="cloudFile.customInfo"
      :document-type="cloudFile.documentType"
      :lob="job.lob"
      :op-button="false"
      :show-all="true"
    />
  </div>
</template>

<script>
import CargoGridShowBigContent from '@/components/Cargo/grid/cargoGridShowBigContent'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import CargoDateTimePicker from '@/components/Cargo/Common/CargoDateTimePicker'
import { stateQueryClickHandler } from '@/class/cargo/model/utils/file'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import {
  cancelReturnFileHandler, getFileByCustomerIdHandler, getInvoiceByJobHandler, queryHasClearingStateFileHandler
} from '@/api/seaExport/file'
import ColumnUtils from '@/utils/ColumnUtils'
import dcSendOutWindow from '@/views/cargo/v0/Clearing/components/DocumentCirculation/dcSendOutWindow'
import DcTakeBackWindow from '@/views/cargo/v0/Clearing/components/DocumentCirculation/dcTakeBackWindow'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import fileDialog from '@/components/Cargo/Job/fileDialog'
import dcReturnWindow from '@/views/cargo/v0/Clearing/components/DocumentCirculation/dcReturnWindow'
import BackListWindow from '@/views/cargo/v0/Clearing/components/DocumentCirculation/backListWindow'
import CollectInfoWindow from '@/views/cargo/v0/Clearing/components/DocumentCirculation/collectInfoWindow'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import { CustomsInfo } from '@/class/model/booking/CustomsInfo'
import cargoCustomInfoFileUpload from '@/components/Cargo/Common/cargoCustomInfoFileUpload'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'ManagementOfWithdrawalDetail',
  components: {
    CollectInfoWindow,
    BackListWindow,
    DcTakeBackWindow,
    CargoAdvanceSelect,
    cargoUserSelect,
    CargoDateTimePicker,
    dcSendOutWindow,
    fileDialog,
    stateQueryClickHandler,
    cargoCompanySelect,
    cargoTemplateSelectorDialog,
    CargoGridShowBigContent,
    cargoDepartmentSelect,
    dcReturnWindow,
    cargoCustomInfoFileUpload
  },
  props: {
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      fileTypeList: getCacheListByKey(basicCacheKeys.basic_data_TransmitFileType),
      query: {
        fileNo: '',
        jobNo: '',
        bookingAgent: 0,
        jobHbl: '',
        loadingPortCode: '',
        destinationPortCode: '',
        customerId: 0,
        customsBroker: 0,
        clearState: '',
        jobSales: 0,
        companyCName: '',
        customerRefNo: '',
        customsNo: '',
        portType: 'SE',
        soNo: '',
        jobLobs: [],
        jobSalesDepartments: [],
        status: '',
        jobOp: 0,
        jobBookingAgent: 0,
        vessel: '',
        timeType: 0,
        timeStart: null,
        timeEnd: null,
        fileTypes: [],
        jobMbl: '',
        voyageFlight: '',
        jobCarrierId: 0
      },
      timeTypes: [
        { label: this.$t('Clearing.FetchDate'), value: 0 },
        { label: this.$t('Clearing.ReturnDate'), value: 1 },
        { label: this.$t('Clearing.DeclarationDate'), value: 2 },
        { label: this.$t('Clearing.SailingDate'), value: 3 },
        { label: this.$t('Clearing.OperationDate'), value: 4 }
      ],
      cTypes: [
        { label: this.$t('CargoMsg.Cargo_CollectedInFull'), value: '1' },
        { label: this.$t('CargoMsg.Cargo_NotCollectedInFull'), value: '0' }
      ],
      businessList: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          // 选中 勾选框或者其他列 都会触发
          onCellFocused: (event) => {
            this.onGridCellFocused(event)
          },
          // 行点击事件
          onRowClicked: this.onRowClickedByBL,
          // 行勾选事件
          onRowSelected: this.onRowSelected,
          defaultColDef: {
            resizable: true
          },
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: '', width: 30, checkboxSelection: true,
            suppressSorting: true, suppressMenu: true, suppressSizeToFit: true, suppressResize: true,
            headerCheckboxSelection: true
          },
          { headerName: this.$t('SeaExport.BusinessNo'), field: 'jobNo', width: 180, colId: 'jobNo' },
          { headerName: this.$t('SeaExport.FileType'), field: 'fileType', width: 180, colId: 'fileType',
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TransmitFileType, 'code', params.value, 'name')
            }
          },
          { headerName: this.$t('SeaExport.FileNo'), field: 'fileNo', width: 180, colId: 'fileNo' },
          { headerName: this.$t('SeaExport.OperatingCompany'), field: 'companyCName', width: 180, colId: 'companyCName' },
          { headerName: this.$t('SeaExport.CustomerLevel'), field: 'customerTypeId', width: 180, colId: 'customerTypeId',
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CustomerType, 'typeId', params.value || 0, 'chineseName')
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_SettlementType'), field: 'invoiceMode', width: 180, colId: 'invoiceMode',
            cellRenderer: params => {
              return params.value === 1 ? this.$t('CargoMsg.Cargo_Monthly') : this.$t('CargoMsg.Cargo_SettlementByBill')
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_ContractStatus'), field: 'bContract', width: 180, colId: 'bContract',
            cellRenderer: params => {
              return params.value === '1' ? this.$t('Clearing.Contracted') : (params.data.endDate ? this.$t('Clearing.ContractExpired') : this.$t('Clearing.Uncontracted'))
            }
          },
          { headerName: this.$t('SeaExport.SendingDate'), field: 'sendDate', width: 180, colId: 'sendDate',
            cellRenderer: params => {
              return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
            }
          },
          { headerName: this.$t('SeaExport.ReceivingDate'), field: 'backDate', width: 180, colId: 'backDate',
            cellRenderer: params => {
              return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
            }
          },
          { headerName: this.$t('SeaExport.Receiver'), field: 'backUser', width: 180, colId: 'backUser',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.ReturnDate'), field: 'returnDate', width: 180, colId: 'returnDate',
            cellRenderer: params => {
              return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
            }
          },
          { headerName: this.$t('SeaExport.DateOfDeclaration'), field: 'declareDate', width: 180, colId: 'declareDate',
            cellRenderer: params => {
              return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
            }
          },
          { headerName: this.$t('SeaExport.Status'), field: 'state', width: 180, colId: 'state',
            cellRenderer: params => {
              return ColumnUtils.fileStatusLabelFunc(params.value)
            }
          },
          { headerName: this.$t('SeaExport.DepartureTime'), field: 'etd', width: 180, colId: 'etd',
            cellRenderer: params => {
              return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
            }
          },
          { headerName: this.$t('SeaExport.Customer'), field: 'customerId', width: 180, colId: 'customerId',
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.CustomsBroker'), field: 'customsBroker', width: 180, colId: 'customsBroker',
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.Sales'), field: 'salesId', width: 180, colId: 'salesId',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.SalesDepartment'), field: 'salesDept', width: 180, colId: 'salesDept',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.Mbl2'), field: 'mbl', width: 180, colId: 'mbl' },
          { headerName: this.$t('SeaExport.Vessel'), field: 'vessel', width: 180, colId: 'vessel' },
          { headerName: this.$t('SeaExport.Voyage'), field: 'voyageFlight', width: 180, colId: 'voyageFlight' },
          { headerName: this.$t('SeaExport.PortOfDestination'), field: 'destinationPortCode', width: 180, colId: 'destinationPortCode',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            }
          },
          { headerName: this.$t('SeaExport.Quantity'), field: 'quantityActual', width: 180, colId: 'quantityActual',
            cellRenderer: (params) => {
              return ColumnUtils.formatNumber(params.value, 0, true)
            }
          },
          { headerName: this.$t('SeaExport.Weight2'), field: 'weightActual', width: 180, colId: 'weightActual',
            cellRenderer: (params) => {
              return ColumnUtils.formatNumber(params.value, 2, true)
            }
          },
          { headerName: this.$t('SeaExport.ReturnExpressNumber'), field: 'returnExpressNo', width: 180, colId: 'returnExpressNo' },
          { headerName: this.$t('SeaExport.DateOfCreation'), field: 'dateCreated', width: 180, colId: 'dateCreated',
            cellRenderer: params => {
              return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
            }
          },
          { headerName: this.$t('SeaExport.Creator'), field: 'inputBy', width: 180, colId: 'inputBy',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.TakeByCustomsBroker'), field: 'tax', width: 180, colId: 'tax',
            cellRenderer: params => {
              return params.value ? this.$t('Clearing.Yes') : this.$t('Clearing.No')
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_WriteOffStatus'), field: 'aramount', width: 180, colId: 'aramount',
            cellRenderer: params => {
              return (params.data.arAmount === 0 || !params.data.arAmount) ? this.$t('CargoMsg.Cargo_CollectedInFull') : this.$t('CargoMsg.Cargo_NotCollectedInFull')
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_InvoiceDate'), field: 'invoiceDate', width: 180, colId: 'invoiceDate',
            cellRenderer: params => {
              return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_ViewFile'), field: 'originFileId', width: 180, colId: 'originFileId', noExport: true,
            cellRenderer: params => {
              if (params.value) {
                return '<a style="color: #0A0AFF; text-decoration: underline">' + this.$t('SeaExport.ChargebackFile') + '</a>'
              } else {
                return ''
              }
            },
            onCellClicked: (params) => {
              this.customFileUploadHandler(params)
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remark', width: 180, colId: 'remark' }

        ],
        rowData: [],
        gridParams: {},
        total: 0,
        filter: {
          pageNum: 1,
          pageSize: 10,
          branchId: 0
        },
        selectedData: {}
      },
      editDialog: {
        visible: false,
        isRemarkOnly: false
      },
      // 文件操作按钮
      opButton: {
        gatherBtn: false,
        backListBtn: false,
        btCancelReturn: false,
        btReturn: false
      },
      // 送出弹框
      sendOutDialog: {
        visible: false,
        sendType: 1,
        customerType: 1,
        printFlag: false,
        formData: {
          receiveCompany: '',
          receivePerson: '',
          receiveAddress: '',
          receiveTel: '',
          expressNo: ''
        }
      },
      // 取回弹框
      takeBackDialog: {
        visible: false,
        dataLabel: '',
        dataLabelTitle: '',
        backDate: '',
        startDate: '',
        selectedFiles: [],
        selectableRange: ''
      },
      // 退还
      returnDialog: {
        visible: false,
        printFlag: false,
        formData: {
          customerId: 0,
          companyCName: '',
          receiver: '',
          tel: '',
          address: '',
          expressNo: '',
          returnDate: ''
        }
      },
      job: {
        lob: '',
        soNo: '',
        uuid: '',
        containerLoadType: '',
        bookingAgent: '',
        customerId: 0,
        customerContact: '',
        opOffice: 0,
        mbl: '',
        customsBroker: 0
      },
      backList: {
        rowList: [],
        visible: false
      },
      collectInfo: {
        rowList: [],
        visible: false
      },
      cloudFile: {
        visible: false,
        title: this.$t('Clearing.ViewReturnOrderFiles'),
        customInfo: new CustomsInfo(),
        documentType: 'Oback'
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        category: 'FileList',
        data: {}
      },
      gridApi: null,
      selectedFiles: [],
      cbAutoRefresh: true
    }
  },
  computed: {

  },
  async created() {
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.office = cache.office
  },
  beforeMount() {

  },
  beforeDestroy() {

  },
  methods: {
    onGridReady(p) {
      this.gridApi = p.api
    },
    clearPage() {
      this.query = PriceUtils.resetFilter(this.query)
      this.query.portType = 'SE'
    },
    queryHandler() {
      this.businessList.filter.pageNum = 1
      this.toQueryByPage()
    },
    setQuerySelectValue(obj) {
      this.query[obj.key] = obj.value
    },
    // 参考老cargo去除中文重复
    dataFilterFunc(item) {
      const typeMap = {}
      for (const tUuid of this.fileTypeList) {
        typeMap[tUuid.name] = tUuid.uuid
      }
      const nowType = typeMap[item.name]
      if (nowType && nowType === item.uuid) {
        return true
      }
      return false
    },
    getVesselAndVoyage() {
      let v = ''
      if (this.businessList.selectedData.vessel) {
        v = this.businessList.selectedData.vessel
      }
      if (this.businessList.selectedData.voyageFlight) {
        v += this.businessList.selectedData.voyageFlight
      }
      return v
    },
    // 查询
    toQueryByPage() {
      Object.keys(this.query).forEach((key) => {
        this.businessList.filter[key] = this.query[key]
      })
      this.businessList.filter.pageNum = this.businessList.filter.pageNum
      this.businessList.filter.pageSize = this.businessList.filter.pageSize
      this.businessList.filter.branchId = this.$store.getters.currentOfficeId
      this.businessList.selectedData = {}
      this.checkButtonState()
      this.loading = getLoading()
      queryHasClearingStateFileHandler(this.businessList.filter).then(res => this.handleQueryData(res)).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      this.businessList.rowData = res.data.list
      this.businessList.filter.pageNum = res.data.pageNum
      this.businessList.filter.pageSize = res.data.pageSize
      this.businessList.total = Number(res.data.total)
      // 初始化选中业务
      this.businessList.selectedData = {}
      if (this.businessList.rowData.length > 0) {
        this.businessList.selectedData = this.businessList.rowData[0]
      }
      this.gridApi.clearFocusedCell()
      this.loading.close()
    },
    // 行点击触发事件
    onRowClickedByBL(event) {
      if (!event) return
      this.businessList.selectedData = {}
      const node = event.data
      if (node) {
        this.businessList.selectedData = node
        Object.keys(this.job).forEach((key) => {
          this.job[key] = node[key]
          this.job.uuid = node['jobUuid']
        })
        this.checkButtonState()
      }
    },
    onRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        this.selectedFiles.push(event.data)
      } else {
        this.selectedFiles = this.gridApi.getSelectedRows()
      }
      this.onRowClickedByBL(event)
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.businessList.selectedData = {}
      if (this.gridApi) {
        this.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            const file = node.data
            if (file.uuid) {
              this.businessList.selectedData = file
              Object.keys(this.job).forEach((key) => {
                this.job[key] = file[key]
                this.job.uuid = file['jobUuid']
              })
              this.checkButtonState()
            }
          }
        })
      }
    },
    checkSelectedData() {
      if (this.businessList.selectedData && this.businessList.selectedData.uuid) {
        return true
      }
      return false
    },
    // 检查按钮状态
    checkButtonState() {
      if (this.checkSelectedData()) {
        this.opButton.backListBtn = true
        this.opButton.gatherBtn = true
      } else {
        this.opButton.backListBtn = false
        this.opButton.gatherBtn = false
      }
      this.opButton.btReturn = false
      this.opButton.btCancelReturn = this.selectedFiles.length > 0
      if (this.selectedFiles.length > 0) {
        this.opButton.btReturn = true
      }
    },
    onSend() {
      this.sendOutDialog.visible = true
      this.sendOutDialog.sendType = 0
      this.sendOutDialog.customerType = this.sendOutDialog.sendType
      this.sendOutDialog.formData.expressNo = this.businessList.selectedData.sendExpressNo
    },
    async successHandler() {
      this.toQueryByPage()
    },
    // 更新列表值
    backSuccessHandler(event) {
      if (event) {
        for (const file of event) {
          const index = this.businessList.rowData.findIndex(row => { return row.uuid === file.uuid })
          const rowData = this.businessList.rowData
          rowData[index] = file
          this.businessList.rowData = [...rowData]
        }
      }
      // 初始化选中业务
      this.businessList.selectedData = {}
      this.selectedFiles = []
      this.gridApi.clearFocusedCell()
      this.checkButtonState()
    },
    customFileUploadHandler(params) {
      if (params.value) {
        this.cloudFile.visible = true
        this.cloudFile.customInfo.uuid = params.value
      }
    },
    // 批量取回
    onBack() {
      const rows = this.gridApi.getSelectedRows()
      const isCustomsOneself = parseInt(cache.config.get('customsOneself'))
      const list = []
      for (const file of rows) {
        if (isCustomsOneself) {
          if (file.state === 0 || file.state === 1) {
            list.push(file)
          }
        } else {
          if (file.state === 1) {
            list.push(file)
          }
        }
      }
      if (list.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoFileToRetrieve'))
        return
      }
      this.takeBackDialog.visible = true
      this.takeBackDialog.dataLabel = this.$t('Message.GetBack') + this.$t('CargoMsg.Cargo_Date')
      this.takeBackDialog.dataLabelTitle = this.$t('SeaExport.Documents') + this.$t('Message.GetBack')
      this.takeBackDialog.dataField = 'sendDate'

      // 赋值 日期区间
      let minDate = null
      for (const file of list) {
        if (!minDate) {
          minDate = file[this.takeBackDialog.dataField]
        } else if (file[this.takeBackDialog.dataField] && minDate.time > file[this.takeBackDialog.dataField].time) {
          minDate = file[this.takeBackDialog.dataField]
        }
      }
      this.takeBackDialog.selectedFiles = list
      this.takeBackDialog.startDate = minDate
      this.takeBackDialog.backDate = new Date()
      this.takeBackDialog.selectableRange = { 'rangeStart': minDate }
    },
    // =============================退还 begin==================================
    onReturn() {
      this.selectedFiles = this.gridApi.getSelectedRows()
      if (!this.selectedFiles || this.selectedFiles.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const blocks = this.getCreditFileSetting()
      if (blocks.hasOwnProperty('back') && blocks['back'] === '1') {
        let tip = ''
        for (const file of this.selectedFiles) {
          if (file.blocked) {
            tip += file.jobNo
          }
        }
        if (tip !== '') {
          this.$message.warning(this.$t('SeaExport.Cargo_FJTLCTW') + tip)
          return
        }
      }
      this.checkSubmitFileBack = parseInt(cache.config.get('BookingSubmitFileBack')) === 0
      let state = -1
      for (const file of this.selectedFiles) {
        if (state === -1) {
          state = file.state
        }
        if (this.checkSubmitFileBack && file.jobState < 1 || this.job.jobState === 13) {
          this.$message.warning(this.$t('SeaExport.BusinessNotSubmitted'))
          return
        }
        if (file.state !== 2 && file.state !== 3) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ORORDCBO'))
          return
        } else if (state !== file.state) {
          this.$message.warning(this.$t('Clearing.OnlyWithTheSameStatus'))
          return
        }
      }
      let error = false
      for (const file of this.selectedFiles) {
        if (file.jobState !== 2) {
          error = true
          break
        }
      }
      if (error) {
        this.$confirm(this.$t('CargoMsg.Cargo_LBNRYSTW'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => this.prePrint())
      } else {
        this.prePrint()
      }
    },
    // 撤销退还
    onCancelReturn() {
      let isCancelBack = false
      this.selectedFiles = this.gridApi.getSelectedRows()
      for (const file of this.selectedFiles) {
        if (file.state === 3) {
          isCancelBack = true
          break
        }
      }
      if (!isCancelBack) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoFileToRevoke'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureToRevokeWithdrawal'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        try {
          this.loading = getLoading()
          const fileList = []
          for (const file of this.selectedFiles) {
            file.returnExpressNo = null
            file.state = 2
            file.returnDate = null
            file.returnPerson = 0
            fileList.push(file)
          }
          // 调用后端保存
          cancelReturnFileHandler(fileList).then(res => {
            this.backSuccessHandler(fileList)
          })
        } finally {
          this.loading.close()
          this.$message.success(this.$t('CargoMsg.Cargo_RevokedSuccessfully'))
        }
      }).catch(() => {
        this.loading.close()
      })
    },
    prePrint() {
      this.returnDialog.formData.returnDate = new Date()
      if (this.selectedFiles === null || this.selectedFiles.length === 0) return
      const file = this.selectedFiles[0]
      this.returnDialog.formData.companyCName = file.receiveCompany
      this.returnDialog.formData.customerId = file.customerId
      this.returnDialog.formData.receiver = file.receivePerson
      this.returnDialog.formData.tel = file.receiveTel
      this.returnDialog.formData.address = file.expressAddress
      this.returnDialog.formData.expressNo = file.returnExpressNo
      this.returnDialog.visible = true
    },
    getCreditFileSetting() {
      const setting = cache.config.get('creditBlockFile')
      var d = {}
      var a = []
      a = setting.split(',')
      for (const o of a) {
        d[o.split('-')[0]] = o.split('-')[1]
      }
      return d
    },
    // =============================退还 end==================================
    onPrint() {
      this.selectedFiles = this.gridApi.getSelectedRows()
      if (this.selectedFiles.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectRecord'))
        return
      }
      const params = {}
      params.FILE_UUID = Array.from(this.selectedFiles, p => p.uuid)
      if (this.job) {
        params.jobuuid = this.job.uuid
      }
      this.templateSelectorDialog.category = 'FileList'
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.visible = true
    },
    // 退还列表
    async popUpBackList() {
      if (this.businessList.selectedData) {
        this.backList.rowList = []
        const fileNo = this.businessList.selectedData.fileNo
        if (!this.businessList.selectedData.customerId) {
          return
        }
        await getFileByCustomerIdHandler(this.businessList.selectedData.customerId).then(res => {
          const list = []
          for (const item of res.data) {
            if (item.fileNo !== fileNo) {
              list.push(item)
            }
          }
          this.backList.visible = true
          this.backList.rowList = list || []
        })
      }
    },
    // 收款信息
    async popUpInvoiceInfo() {
      if (this.businessList.selectedData) {
        this.collectInfo.rowList = []
        await getInvoiceByJobHandler(this.businessList.selectedData.jobUuid).then(res => {
          this.collectInfo.visible = true
          this.collectInfo.rowList = res.data || []
        })
      }
    },
    async visibleHandler() {
      this.collectInfo.visible = false
      this.backList.visible = false
    }
  }
}
</script>

<style lang="scss">
#app #verify-tree-grid {
  .ag-theme-balham {
  }
  .main-inner-row {
    display: flex;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .query-input-spacing {
    padding-right: 10px;
  }
}
</style>
